/**
 * 订单路由
 */
export default [
  {
    path: '/order/myOrderList',
    name: 'MyOrderList',
    component: (resolve) => require(['@/views/order/myOrderList'], resolve)
    // meta: {
    //   keepAlive: true
    // }
  },
  // 我的订单列表页
  {
    path: '/mine/order/index',
    name: 'OrderIndex',
    component: (resolve) => require(['@/views/mine/order/index'], resolve)
  },
  // 确认订单列表页
  {
    meta: {
      keepAlive: true,
      isBack: false
    },
    path: '/order/confirmOrder',
    name: 'ConfirmOrder',
    component: (resolve) => require(['@/views/order/confirmOrder'], resolve)
  },
  // 报名信息页面
  {
    meta: {
      keepAlive: true,
      isBack: false
    },
    path: '/order/perfectInfo',
    name: 'perfectOrderStudentInfo',
    component: (resolve) => require(['@/views/order/perfectInfo'], resolve)
  },
  // 编辑报名学生信息页面
  {
    path: '/order/editPerfectStudent',
    name: 'editPerfectStudent',
    component: (resolve) => require(['@/views/order/editPerfectStudent'], resolve)
  },
  // 退款页
  {
    path: '/order/drawback',
    name: 'Drawback',
    component: (resolve) => require(['@/views/order/drawback'], resolve)
  },

  // 退款规则
  {
    path: '/order/drawbackRules',
    name: 'DrawbackRules',
    component: (resolve) => require(['@/views/order/drawbackRules'], resolve)
  },

  // 退款
  {
    path: '/order/requestDrawback',
    name: 'RequestDrawback',
    component: (resolve) => require(['@/views/order/requestDrawback'], resolve)
  },

  // 订单详情页
  {
    path: '/order/orderDetails',
    name: 'OrderDetails',
    component: (resolve) => require(['@/views/order/orderDetails'], resolve)
  },
  // 换课
  {
    path: '/order/change/lesson',
    name: 'ChangeLesson',
    component: (resolve) => require(['@/views/order/change-lesson/index'], resolve)
  },
  // 换课规则
  {
    path: '/order/change/lesson/rules',
    name: 'ChangeLessonRules',
    component: (resolve) => require(['@/views/order/change-lesson/rules'], resolve)
  },
  // 换课历史记录
  {
    path: '/order/change/lesson/history',
    name: 'ChangeLessonHistory',
    component: (resolve) => require(['@/views/order/change-lesson/history'], resolve)
  },
  // 支付成功页面
  {
    path: '/order/paySuccess',
    name: 'PaySuccess',
    component: (resolve) => require(['@/views/order/payResult'], resolve)
  },
  // 支付失败页面
  {
    path: '/order/payFail',
    name: 'PayFail',
    component: (resolve) => require(['@/views/order/payResult'], resolve)
  },
  // 支付中页面
  {
    path: '/order/payProcess',
    name: 'PayProcess',
    component: (resolve) => require(['@/views/order/payResult'], resolve)
  },
  {
    path: '/order/wechatPay',
    name: 'wechatPay',
    component: (resolve) => require(['@/views/order/wechatPay'], resolve)
  }
];




// WEBPACK FOOTER //
// ./src/router/modules/order.js